export function hasNoAnswers(answers) {
  return answers !== undefined && answers !== null && answers.length === 0;
}

export function generateSuccess() {
  return {
    help: '',
    valid: true,
    validationState: 'success'
  };
}

export function generateError(helpMessage) {
  return {
    help: helpMessage,
    valid: false,
    validationState: 'error'
  };
}



// WEBPACK FOOTER //
// ./src/components/questionnaire/validators/validationHelpers.js